import type { ReactNode } from "react";

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-screen bg-paper text-ink lg:grid-cols-[1.05fr_0.95fr]">
      <section className="brand-grid relative hidden overflow-hidden bg-ink text-white lg:flex">
        <div className="relative z-10 flex min-h-screen w-full flex-col justify-between p-12">
          <div>
            <div className="flex items-center gap-3">
              <div className="grid-mark" aria-hidden="true">
                <span />
                <span />
                <span />
                <span />
              </div>
              <p className="text-lg font-semibold">CoachGrid</p>
            </div>

            <div className="mt-24 max-w-xl">
              <p className="eyebrow text-mint/80">Coaching workspace</p>
              <h1 className="mt-4 text-5xl font-semibold leading-tight tracking-normal">
                Run your coaching business from one clean workspace.
              </h1>
              <p className="mt-6 max-w-lg text-lg leading-8 text-white/70">
                Clients, check-ins, training plans and progress organised
                without the spreadsheet chaos.
              </p>
            </div>
          </div>

          <div className="auth-signal-panel">
            <div>
              <p className="text-xs uppercase text-white/45">Workspace</p>
              <p className="mt-2 text-sm font-medium text-white">CoachGrid OS</p>
            </div>
            <div className="grid grid-cols-4 gap-2">
              {["Clients", "Plans", "Checks", "Progress"].map((label) => (
                <div className="rounded-md border border-white/10 p-3" key={label}>
                  <div className="h-1.5 rounded-full bg-mint/70" />
                  <p className="mt-3 text-xs text-white/60">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <main className="flex min-h-screen items-center justify-center px-5 py-10 sm:px-8">
        <div className="w-full max-w-[440px]">
          <div className="mb-10 flex items-center gap-3 lg:hidden">
            <div className="grid-mark grid-mark-dark" aria-hidden="true">
              <span />
              <span />
              <span />
              <span />
            </div>
            <p className="text-lg font-semibold">CoachGrid</p>
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
